export const FEATURE_GATES = {
  BETA_USERS: "beta_users",
  CRM_ACTION_BAR: "crm_action_bar",
  ENTERPRISE_GPT: "enterprise_gpt",
  GOOGLE_MEET_INTEGRATION: "google_meet_integration",
  GOOGLE_REVIEW: "google_review",
  MICROSOFT_ONEDRIVE_INTEGRATION: "microsoft_onedrive_integration",
  READ_EMAILS: "read_emails",
  PUSH_TO_SALESFORCE: "push_to_salesforce",
  GOOGLE_DRIVE_INTEGRATION: "google_drive_integration",
} as const;

export type FeatureGate = (typeof FEATURE_GATES)[keyof typeof FEATURE_GATES];
